import { connect } from 'react-redux'

import { register, registerSocialsError } from './reducer'

const mapStateToProps = (state) => {
    return {
        isAuth: state?.services?.auth?.isAuthorized,
        loading: state?.pages?.register?.loading,
        error: state?.pages?.register?.error,
        errorType: state?.pages?.register?.errorType,
    }
}

const hocConnect = (InnerComponent) =>
    connect(mapStateToProps, {
        register,
        registerSocialsError,
    })(InnerComponent)

export default hocConnect
